import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
const { HIGHLIGHT_COLOR } = constants;

let styles = {
  base: {
    display: 'block',
    position: 'relative',
    cursor: 'pointer',
    userSelect: 'none',
    margin: '2px 0',
    width: 100,

    ':hover input ~ span': {
      borderColor: '#bbb'
    }
  },
  check: {
    position: 'absolute',
    left: '50%',
    top: '10%',
    fontSize: '0.9em'
  },
  truecheck: {
    fontSize: '1.1em',
    color: '#00ff00',
    fontWeight: 'bolder',
    left: '48%'
  },
  falsecheck: {
    color: '#ff0000'
  },

  input: {
    opacity: 0,
    cursor: 'pointer',
    ':checked ~ span:after': {
      display: 'block'
    }
  },
  checkmark: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: 8,
    width: 8,
    backgroundColor: 'transparent',
    border: `2px solid ${HIGHLIGHT_COLOR}`,
    borderRadius: 3,
    ':after': {
      content: '""',
      position: 'absolute',
      display: 'none',
      left: 1,
      top: -1,
      width: 3,
      height: 6,
      borderRight: `solid ${HIGHLIGHT_COLOR}`,
      borderBottom: `solid ${HIGHLIGHT_COLOR}`,
      transform: 'rotate(45deg)'
    }
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/inputs/checkboxcontrol/CheckboxControl.styles.js